import { useContext } from "react";
import { useParams } from "react-router-dom";

import { CreateSystemRequest } from "../../api/CreateSystemRequest";
import { useAdminSystemApi } from "../../api/useAdminSystemApi";
import { SystemContext } from "../../context/SystemContext";
import { CreateSystemFormInputs } from "./CreateSystemFormInputs";

export const useCreateSystemForm = () => {
    const { createSystem } = useAdminSystemApi();
    const { integratorId } = useParams<{ integratorId: string }>();
    const { addSystemItem } = useContext(SystemContext);

    const addSystem = async (inputs: CreateSystemFormInputs): Promise<void> => {
        const { name, description } = inputs;

        const request = createRequest({
            integratorId,
            name,
            description
        });

        const { entityId } = await createSystem(request);

        addSystemItem({
            id: entityId,
            name,
            description,
            updatedDate: new Date().toISOString()
        });
    };

    return {
        addSystem
    };
};

const createRequest = (params: { integratorId: string; name: string; description: string }): CreateSystemRequest => {
    return {
        integratorId: params.integratorId,
        name: params.name,
        description: params.description
    };
};
